import React, { memo } from 'react'
import { BWPoweredByQb } from 'src/libs/qb-brand-web-components'

import poweredByLogo from '../../../../assets/powered-by-qb.png'

const PoweredByWrapper = () => <BWPoweredByQb qbxLogo={poweredByLogo} />

export default memo(PoweredByWrapper)
